/** Copies `value`; resolves `false` (never throws) when the browser refuses, so callers only claim success on `true`. */
export const copyToClipboard = async (value: string): Promise<boolean> => {
  try {
    // doesn't work in some browsers and without https
    if (typeof document === 'undefined' || typeof navigator === 'undefined') {
      return false
    }

    if ('clipboard' in navigator) {
      await navigator.clipboard.writeText(value)
    } else {
      const textarea = document.createElement('textarea')
      textarea.value = value
      document.body.appendChild(textarea)
      textarea.select()
      const copied = document.execCommand('copy')
      document.body.removeChild(textarea)

      return copied
    }

    return true
  } catch (err) {
    console.error('Failed to copy: ', err)

    return false
  }
}
